<template>
	<div class="plans-page" :style="fundo">
		<div class="plans-title">
			<h2 style="color: #00c0ca">NOSSOS PLANOS PARA EMPRESAS</h2>
		</div>
		<div class="plans-box">
			<div class="plans-type" style="border-bottom: 1px solid white">
				<div class="plans-type_title">
					<i class="fas fa-user" style="color: #faf04d"></i>
					<h2 style="color: #faf04d">BÁSICO</h2>
					<p>Indicados para pequenas e médias empresas</p>
				</div>
				<div class="plans-type_values">
					<h2 style="text-decoration: line-through">R$99,90</h2>
					<div class="plans-price">
						R$
						<h1>49</h1>
						,90
					</div>
					<p>*Nos primeiros 12 meses</p>
					<p><i class="fas fa-desktop"></i>Portal de Autonegociação;</p>
					<p><i class="fas fa-compass"></i>CRM de cobranças;</p>
					<p><i class="fas fa-chart-bar"></i>Dashboards e relatórios;</p>
					<!-- <p><i class="fas fa-analytics"></i>Dashboards e relatórios;</p> -->
					<p><i class="fas fa-bullseye"></i>Campanhas;</p>
					<!-- <p><i class="fas fa-bullseye-arrow"></i>Campanhas;</p> -->
				</div>
			</div>
			<div class="plans-type">
				<div class="plans-type_title">
					<i class="fas fa-users" style="color: #faf04d"></i>
					<h2 style="color: #faf04d">PREMIUM</h2>
					<p>Indicado para carteiras maiores e volume mensal</p>
				</div>
				<div class="plans-type_values">
					<h2>A partir de</h2>
					<div class="plans-price">
						R$
						<h1>159</h1>
						,90
					</div>
					<p><i class="fas fa-cogs"></i> Automação do processo;</p>
					<p><i class="fas fa-hand-holding-usd"></i> Carteira e planejamento;</p>
					<p><i class="fas fa-suitcase"></i> Muito mais vantagens;</p>
					<!-- <p><i class="fas fa-box-usd"></i> Muito mais vantagens;</p> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		fundo: function() {
			return {
				"--fundoFull": "url(" + require(`../../../assets/images/plans.svg`) + ")"
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.plans-page {
	background-position: center;
	background-attachment: fixed;
	background-size: cover;
	background-image: var(--fundoFull);
	display: grid;
	grid-template-columns: 50% 50%;
}
.plans-title {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 25%;
	h2 {
		font-family: "Montserrat-Bold";
		font-size: 28px;
	}
}
.plans-type {
	display: grid;
	margin: 3em;
	padding-bottom: 2em;
	grid-template-columns: 40% 60%;
}
.plans-type_title {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	i {
		font-size: 48px;
	}
	h2 {
		font-family: "Montserrat-Bold";
		font-size: 28px;
	}
}
.plans-type_values {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	color: white;
	margin-left: 2em;
	p {
		margin-top: 1em;
		i {
			margin-right: 1em;
		}
	}
	h2 {
		font-size: 16px;
	}
}
.plans-price {
	display: flex;
	align-items: baseline;
	font-family: "Montserrat-Bold";
	font-size: 20px;
	h1 {
		font-family: "Montserrat-Bold";
		font-size: 40px;
	}
}
</style>